var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('count-down',{staticClass:"count-down-block",class:{'mobile': _vm.isMobile, 'gradient': _vm.gradient},style:(Object.assign({}, _vm.styles)),attrs:{"value":new Date(_vm.currentEvent.startTime)}})}
var staticRenderFns = []

export { render, staticRenderFns }